import { Injectable } from '@angular/core';

import { CodedStatusMessage } from '@core/models/coded-status-message.model';
import { EntityTypeLabels } from '@core/services/gbe-error-parser/entity-ref-labels';
import { WarningOccurrence } from '@core/services/gbe-error-parser/warning.model';

import { AnchoredPopupState } from '@shared/services/anchored-popup/anchored-popup-state';

/** What the panel hands the card: one occurrence, plus the group it was found under. */
export interface FindingCardData {
  title: string;
  code: string;
  occurrence: WarningOccurrence;
  raw: CodedStatusMessage;
  typeLabels: EntityTypeLabels;
}

/** Root singleton: one finding card open at a time, app-wide. */
@Injectable({ providedIn: 'root' })
export class FindingCardPopupService extends AnchoredPopupState<FindingCardData> {}
